/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Elegant_Gaudy_Cat_ComfortInputs */

const fr_elegant_gaudy_cat_comfort = /** @type {(inputs: Elegant_Gaudy_Cat_ComfortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

/**

* @param {Elegant_Gaudy_Cat_ComfortInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const elegant_gaudy_cat_comfort = /** @type {((inputs?: Elegant_Gaudy_Cat_ComfortInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Elegant_Gaudy_Cat_ComfortInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_elegant_gaudy_cat_comfort(inputs)
});